import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PageSelectorComponent } from './components/page-selector/page-selector.component';
import { PageSelectorEffects } from './page-selector.effects';
import { featureKey, reducer } from './page-selector.reducer';

@NgModule({
  declarations: [PageSelectorComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    StoreModule.forFeature(featureKey, reducer),
    EffectsModule.forFeature([PageSelectorEffects]),
    NgxMatSelectSearchModule,
  ],
  exports: [PageSelectorComponent],
})
export class PageSelectorModule {}
